import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { AppDispatch } from "@/store";
import { importQSOs, loadQSORecords, clearQSORecords } from "@/store/slices/qso.slice";
import {
  selectAllQSOs,
  selectQSOLoading,
  selectQSOError,
  selectImportProgress,
  selectDuplicateCount,
} from "@/store/selectors/qso.selectors";

export function useQSOs(): {
  qsos: import("@/types/qso.types").QSO[];
  loading: boolean;
  error: string | null;
  importProgress: number;
  duplicateCount: number;
  handleImport: (file: File) => Promise<void>;
  handleClear: () => Promise<void>;
} {
  const dispatch = useDispatch<AppDispatch>();
  const qsos = useSelector(selectAllQSOs);
  const loading = useSelector(selectQSOLoading);
  const error = useSelector(selectQSOError);
  const importProgress = useSelector(selectImportProgress);
  const duplicateCount = useSelector(selectDuplicateCount);

  // 组件挂载时自动加载QSO记录
  useEffect(() => {
    void dispatch(loadQSORecords());
  }, [dispatch]);

  const handleImport = async (file: File): Promise<void> => {
    await dispatch(importQSOs(file));
  };

  const handleClear = async (): Promise<void> => {
    await dispatch(clearQSORecords());
  };

  return {
    qsos,
    loading,
    error,
    importProgress,
    duplicateCount,
    handleImport,
    handleClear,
  };
}
